export default "__VITE_ASSET__CCM$w27___"